import { render, staticRenderFns } from "./SolucoesForm.vue?vue&type=template&id=6f1c6774&scoped=true&"
import script from "./SolucoesForm.vue?vue&type=script&lang=js&"
export * from "./SolucoesForm.vue?vue&type=script&lang=js&"
import style0 from "./SolucoesForm.vue?vue&type=style&index=0&id=6f1c6774&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f1c6774",
  null
  
)

export default component.exports